export default __webpack_public_path__ + "static/media/alquran.053d9d61.jpeg";